import { useEffect, useState } from "react";
import { useAuthStore } from "../../stores/auth.store";
import { useSeasonStore } from "../../stores/season.store";
import { useUserStore } from "../../stores/user.store";
import { LoadingScreen } from "../common/LoadingScreen";

type AuthProviderProps = {
  children: React.ReactNode;
};

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [timeoutId, setTimeoutId] = useState<number>();
  const { initialize: initializeAuth } = useAuthStore();
  const { initialize: initializeUser } = useUserStore();
  const { initialize: initializeSeason } = useSeasonStore();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsInitialized(true);
    }, 2000);
    setTimeoutId(timeoutId as unknown as number);
  }, []);

  useEffect(() => {
    const initialize = async () => {
      await Promise.all([
        initializeAuth(),
        initializeUser(),
        initializeSeason(),
      ]);
      setIsInitialized(true);
      clearTimeout(timeoutId);
    };

    initialize();
  }, [
    initializeAuth,
    initializeUser,
    initializeSeason,
    timeoutId,
  ]);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
};
